import { render, staticRenderFns } from "./AnatomiasFisiologiasTabela.vue?vue&type=template&id=fd9181d0"
import script from "./AnatomiasFisiologiasTabela.vue?vue&type=script&lang=js"
export * from "./AnatomiasFisiologiasTabela.vue?vue&type=script&lang=js"
import style0 from "./AnatomiasFisiologiasTabela.vue?vue&type=style&index=0&id=fd9181d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports